import Navbar from "../components/Navbar/Navbar";
import TopNav from "../components/Navbar/TopNav";

export default function Search() {
  return (
    <div>
      <div>
        <Navbar />
      </div>
      <div>
        <TopNav />
      </div>
    </div>
  );
}
